var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.229,
    height: 13.707,
    viewBox: "0 0 13.229 13.707",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_167615",
    "data-name": "Group 167615",
    transform: "translate(-67.235 -60.484)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49812",
    "data-name": "Path 49812",
    d: "M78.23,71.885a6.488,6.488,0,1,0-2.621,1.46c3.256.748,3.085.72,3.159.72a.342.342,0,0,0,.305-.494Zm-2.631.766a.342.342,0,0,0-.1.014,5.812,5.812,0,1,1,2.085-1.124.342.342,0,0,0-.085.414l.637,1.273C75.547,72.634,75.672,72.652,75.6,72.652Z",
    stroke: "#333",
    strokeWidth: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.12c75249970087519f69337aa7fd04e6.svg";
export { ForwardRef as ReactComponent };